var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CatchphraseSection',{attrs:{"sectionId":"intro-A"},on:{"go-register":function($event){return _vm.$emit('go-register')}}})}
var staticRenderFns = []

export { render, staticRenderFns }